import React from 'react'
import { Navbar, NavDropdown, Container, Nav } from 'react-bootstrap'
function Navbars(props) {
  return props.type === '1' ? (
    <div>
      <Navbar bg="primary" expand="lg">
        <Container fluid>
          <Navbar.Brand href="#">DJCSI LC RC</Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll" style={{ marginRight: '2%' }} className="justify-content-end">
            <Nav className="me-auto my-2 my-lg-0" style={{ maxHeight: '100px' }} navbarScroll>
              <NavDropdown title="Hello Admin!" id="navbarScrollingDropdown" style={{fontWeight:"bolder",color:"black"}}>
              <NavDropdown.Item href="/home">HOME</NavDropdown.Item>
                <NavDropdown.Item href="/upload-data">UPLOAD DATA</NavDropdown.Item>
                <NavDropdown.Item href="/vacation">VACATION</NavDropdown.Item>
                <NavDropdown.Item href="/">LOGOUT</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  ) : (
    <div>
      <Navbar bg="primary" expand="lg">
        <Container fluid>
          <Navbar.Brand href="#">DJCSI LC-RC</Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll" style={{ marginRight: '2%' }} className="justify-content-end">
            <Nav
              className="me-auto my-2 my-lg-0"
              style={{
                maxHeight: '100px',
                justifyContent: 'left',
              }}
              navbarScroll
            >
              <NavDropdown title="HELLO!" id="navbarScrollingDropdown">
                <NavDropdown.Item href="/login"><strong>LOGIN</strong></NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  )
}
export default Navbars
